import React, { useState } from "react";

export const Aside = () => {
  const [activeSection, setActiveSection] = useState(null);

  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };

  return (
    <aside className="sidebarNavigation">
      <h2>Resources</h2>

      {/* About iLEARN */}
      <div>
        <h3 onClick={() => toggleSection("about")}>About iLEARN</h3>
        <ul style={{ display: activeSection === "about" ? "block" : "none" }}>
          <li>
            <a
              href="https://usahs.sharepoint.com/sites/USAHSStudentResources/_layouts/15/AccessDenied.aspx?Source=https%3A%2F%2Fusahs%2Esharepoint%2Ecom%2Fsites%2FUSAHSStudentResources%2FSitePages%2FAbout%2DiLEARN%2Easpx%3Fcsf%3D1%26web%3D1%26e%3DzExR0s%26CT%3D1725569256654%26OR%3DOWA%2DNT%2DMail%26CID%3Dd4cffef5%2Dbf5d%2Dd49b%2D513b%2D0ae3ea569066&correlation=e2614da1%2D305f%2D6000%2D614a%2De4ad66c34b89&Type=item&name=f115de91%2D75aa%2D481c%2Db9ce%2Dd26bc2e6e05d&listItemId=11&listItemUniqueId=a36a9b33%2D94d2%2D4cfb%2Dbadd%2D8152f6be7070"
              target="_blank"
              rel="noopener noreferrer"
            >
              Mission & Advisory Committees
            </a>
          </li>
        </ul>
      </div>

      {/* Academic Success */}
      <div>
        <h3 onClick={() => toggleSection("academicSuccess")}>
          Academic Success
        </h3>
        <ul
          style={{
            display: activeSection === "academicSuccess" ? "block" : "none",
          }}
        >
          <li>
            <a
              href="https://ilearn.usa.edu/allvideos/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Workshops & Recordings
            </a>
          </li>
          <li>
            <a
              href="https://my.usa.edu/ICS/Student_Services/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Student Services
            </a>
          </li>
          <li>
            <a
              href="https://catalog.usa.edu/"
              target="_blank"
              rel="noopener noreferrer"
            >
              University Catalog/Handbook
            </a>
          </li>
        </ul>
      </div>

      {/* Professional Development */}
      <div>
        <h3 onClick={() => toggleSection("professionalDevelopment")}>
          Professional Development
        </h3>
        <ul
          style={{
            display: activeSection === "professionalDevelopment" ? "block" : "none",
          }}
        >
          <li>
            <a href="https://my.usa.edu/ICS/Career_Services/" target="_blank" rel="noopener noreferrer">
              Career Services
            </a>
          </li>
          <li>
            <a href="https://usahs.sharepoint.com/sites/USAHSMicro-Credentials" target="_blank" rel="noopener noreferrer">
              Office of Micro-Credentials
            </a>
          </li>
        </ul>
      </div>

      {/* Clinical Innovation and Technology */}
      <div>
        <h3 onClick={() => toggleSection("clinicalInnovation")}>
          Clinical Innovation and Technology
        </h3>
        <ul
          style={{
            display: activeSection === "clinicalInnovation" ? "block" : "none",
          }}
        >
          <li>
            <a
              href="https://library.usa.edu/library-innovation-and-creation-hub"
              target="_blank"
              rel="noopener noreferrer"
            >
              Innovation and Creation Hub
            </a>
          </li>
          <li>
            <a
              href="https://usahs.sharepoint.com/sites/CentersforInnovativeClinicalPractice"
              target="_blank"
              rel="noopener noreferrer"
            >
              Centers for Innovative Clinical Practice (CICP)
            </a>
          </li>
          <li>
            <a
              href="https://usahs.sharepoint.com/sites/USAHSProBonoClinicalExperiences"
              target="_blank"
              rel="noopener noreferrer"
            >
              Pro Bono Clinical Experiences
            </a>
          </li>
          <li>
            <a
              href="https://help.usa.edu/hc/en-us/articles/360045654154-Technology-Toolkit-for-Online-Learning#TechnologyToolkitforOnlineLearning-CommunicationwithText,Audio,andVideo"
              target="_blank"
              rel="noopener noreferrer"
            >
              Technology Toolbox
            </a>
          </li>
          <li>
            <a
              href="https://usahs.sharepoint.com/sites/ExamSoft101"
              target="_blank"
              rel="noopener noreferrer"
            >
              ExamSoft 101
            </a>
          </li>
        </ul>
      </div>

      {/* Research and Scholarship */}
      <div>
        <h3 onClick={() => toggleSection("research")}>
          Research and Scholarship
        </h3>
        <ul style={{ display: activeSection === "research" ? "block" : "none" }}>
          <li>
            <a href="https://library.usa.edu/" target="_blank" rel="noopener noreferrer">
              USAHS Library
            </a>
          </li>
          <li>
            <a href="https://soar.usa.edu/" target="_blank" rel="noopener noreferrer">
              SOAR@USA
            </a>
          </li>
          <li>
            <a href="https://soar.usa.edu/sjot/" target="_blank" rel="noopener noreferrer">
              Student Journal of Occupational Therapy
            </a>
          </li>
        </ul>
      </div>
    </aside>
  );
};

export default Aside;
